module.exports = __webpack_public_path__ + "img/党参.27e419fd.jpg";